module.exports = __webpack_public_path__ + "static/media/react.4e8d87df.png";